import React from "react";
import { IconProps } from "./IconProps";

const Copy: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_4049_1822)">
                <path
                    d="M4.16663 11.6666C3.39006 11.6666 3.00177 11.6666 2.69549 11.5397C2.28711 11.3706 1.96265 11.0461 1.79349 10.6377C1.66663 10.3314 1.66663 9.94315 1.66663 9.16659V3.49992C1.66663 2.5665 1.66663 2.09979 1.84828 1.74327C2.00807 1.42966 2.26304 1.1747 2.57664 1.01491C2.93316 0.833252 3.39987 0.833252 4.33329 0.833252H9.99996C10.7765 0.833252 11.1648 0.833252 11.4711 0.960119C11.8795 1.12928 12.2039 1.45373 12.3731 1.86211C12.5 2.1684 12.5 2.55668 12.5 3.33325M10.1666 17.4999H15.6666C16.6 17.4999 17.0668 17.4999 17.4233 17.3183C17.7369 17.1585 17.9918 16.9035 18.1516 16.5899C18.3333 16.2334 18.3333 15.7667 18.3333 14.8333V9.33325C18.3333 8.39983 18.3333 7.93312 18.1516 7.5766C17.9918 7.263 17.7369 7.00803 17.4233 6.84824C17.0668 6.66659 16.6 6.66659 15.6666 6.66659H10.1666C9.23321 6.66659 8.7665 6.66659 8.40998 6.84824C8.09637 7.00803 7.8414 7.263 7.68162 7.5766C7.49996 7.93312 7.49996 8.39983 7.49996 9.33325V14.8333C7.49996 15.7667 7.49996 16.2334 7.68162 16.5899C7.8414 16.9035 8.09637 17.1585 8.40998 17.3183C8.7665 17.4999 9.23321 17.4999 10.1666 17.4999Z"
                    stroke={color}
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4049_1822">
                    <rect width={size} height={size} fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Copy;
